import React, { useEffect, useRef, useState } from 'react';
import Chatbot from '../chatbot/Chatbot';

const OutputModule = ({
  timeSeriesData = [],
  currentFrame = 0,
  selectedDepth = 0,
  isCollapsed = true,
  onToggleCollapse,
  className = '',
  data = [],
  dataSource = 'simulated',
  availableDepths = [],
  selectedArea = '',
  selectedModel = 'NGOSF2',
  playbackSpeed = 0.1,
  envData = {},
  timeZone = 'UTC',
  startDate,
  endDate,
  dataLoaded,
  isPlaying = false
}) => {
  const [panelMode, setPanelMode] = useState('assistant');
  const prevIsPlayingRef = useRef(false);

  useEffect(() => {
    if (isPlaying && !prevIsPlayingRef.current) {
      setPanelMode('comms');
    }
    prevIsPlayingRef.current = isPlaying;
  }, [isPlaying]);

  useEffect(() => {
    const onChatAssistant = () => setPanelMode('assistant');
    window.addEventListener('tutorial-focus-chat', onChatAssistant);
    return () => window.removeEventListener('tutorial-focus-chat', onChatAssistant);
  }, []);

  return (
    <div
      data-tutorial="output-module"
      className={`relative flex flex-col h-full bg-white dark:bg-slate-900 overflow-hidden border-l border-slate-200 dark:border-slate-700 ${className} dark:border-yellow-500/30`}
    >
      <div className="flex-1 overflow-hidden min-h-0" data-tutorial="data-panels">
        <div className="h-full min-h-0 flex flex-col" data-tutorial="chatbot">
          <Chatbot
            panelMode={panelMode}
            onPanelModeChange={setPanelMode}
            isPanelCollapsed={isCollapsed}
            onTogglePanelCollapse={onToggleCollapse}
            timeSeriesData={timeSeriesData}
            data={data}
            dataSource={dataSource}
            selectedDepth={selectedDepth}
            availableDepths={availableDepths}
            selectedArea={selectedArea}
            selectedModel={selectedModel}
            playbackSpeed={playbackSpeed}
            currentFrame={currentFrame}
            envData={envData}
            timeZone={timeZone}
            startDate={startDate}
            endDate={endDate}
            dataLoaded={dataLoaded}
          />
        </div>
      </div>
    </div>
  );
};

export default OutputModule;
